<template>
<div class="page-container">
  <div class="card">
    <page-title :title="title"></page-title>
    <div class="card-desc">
      {{ $t('在这里编辑系统基本配置项，定制您的个性化设置') }}
    </div>
  </div>

  <div class="card" v-loading="loading" :element-loading-text="$t('正在加载系统基本配置数据')">
    <div class="config-container">
      <el-row>
        <el-col :md="{span: 14, offset: 5}" :sm="{span: 20, offset: 2}" :xs="24">
          <el-form label-width="140px">
            <!-- 用户头像 -->
            <el-form-item :label="$t('用户默认头像：')">
              <div class="image-info" @click="editAvatar">
                <img :src="configForm.avatar" class="avatar-image"/>
              </div>

            </el-form-item>
            <!-- 上传策略 -->
            <el-form-item :label="$t('上传策略：')">
              <el-tag type="success">{{ $t('MinIO 对象存储') }}</el-tag>
            </el-form-item>
            <el-form-item :label="$t('无操作自动登出：')">
              <div class="idle-logout-setting">
                <el-input-number
                  v-model="configForm.idleLogoutMinutes"
                  :min="1"
                  :max="120"
                  :step="1"
                  :precision="0"
                  size="small"
                  controls-position="right" />
                <span class="setting-unit">{{ $t('分钟') }}</span>
              </div>
              <div class="setting-hint">{{ $t('用户在页面上连续无操作达到该时长后自动退出登录，默认 30 分钟。') }}</div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" style="margin-top: 30px;">
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          plain
          :loading="buttonLoading"
          @click="saveConfig">
          {{ $t('保存配置') }}
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-close"
          size="small"
          plain
          :loading="buttonLoading"
          @click="cancel">
          {{ $t('取消编辑') }}
        </el-button>
      </el-row>
    </div>
  </div>

  <file-space
    :visible="avatarVisible"
    @confirm="changeAvatar"
    :limit="1"
    :text="$t('只能上传 .jpeg .jpg .png .gif 格式的文件，且不超过2MB')"
    :accept="['.jpeg', '.jpg', '.png', '.gif']"
    :size="2"
    @close="closeFileSpace">
  </file-space>
</div>
</template>

<script>
import { translateUi } from '../../../../../i18n'
import PageTitle from '../../../../../components/PageTitle/index.vue'
import FileSpace from '../../../../../components/FileSpace/index.vue'
import { getConfig, saveConfig } from '../../../../../api/system'

export default {
  name: 'Other',

  components: { PageTitle, FileSpace },

  created () {
    // 赋值当前页面内容
    this.title = this.$route.meta.title
    // 获取系统配置
    this.getConfig()
  },

  activated () {
    // 组件被激活时动态获取系统配置
    this.getConfig()
  },

  data () {
    return {
      // 文件空间对话框
      avatarVisible: false,
      // 系统配置表单
      configForm: {
        // 用户默认头像
        avatar: undefined,
        // 上传策略
        uploadStrategy: undefined,
        // 连续无操作后自动退出登录（分钟）
        idleLogoutMinutes: 30
      },
      // 等待框
      loading: false,
      // 按钮加载框
      buttonLoading: false
    }
  },

  methods: {
    // 获取系统基本配置信息
    getConfig () {
      // 等待框
      this.loading = true
      this.buttonLoading = true
      getConfig().then((res) => {
        this.configForm = {
          ...res,
          idleLogoutMinutes: Number(res.idleLogoutMinutes) || 30
        }
        // 关闭等待框
        this.loading = false
        this.buttonLoading = false
      }).catch(() => {
        // 关闭等待框
        this.loading = false
        this.buttonLoading = false
      })
    },
    // 打开文件空间对话框
    editAvatar () {
      this.avatarVisible = true
    },
    // 关闭文件选择框
    closeFileSpace () {
      this.avatarVisible = false
    },
    // 修改默认用户头像
    changeAvatar (value) {
      // 修改当前头像值
      this.configForm.avatar = value[0].src
    },
    // 保存配置信息
    saveConfig () {
      const minutes = Number(this.configForm.idleLogoutMinutes)
      if (!Number.isInteger(minutes) || minutes < 1 || minutes > 120) {
        this.$message.error(translateUi('自动登出时间须为 1 至 120 分钟的整数'))
        return
      }
      this.configForm.idleLogoutMinutes = minutes
      // 开启加载框
      this.loading = true
      this.buttonLoading = true
      saveConfig(this.configForm).then((res) => {
        this.$message.success(translateUi('保存成功'))
        this.loading = false
        this.buttonLoading = false
      }).catch(() => {
        this.loading = false
        this.buttonLoading = false
      })
    },
    // 取消编辑
    cancel () {
      this.getConfig()
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-image {
  width: 100%;
  border-radius: 10px;
}
.card {
  margin-bottom: 20px;
}
.card-desc {
  margin-top: 60px;
}
.config-container {
  margin-top: 30px;
  margin-bottom: 10px;
}
.idle-logout-setting {
  display: flex;
  align-items: center;
  gap: 10px;
}
.setting-unit {
  color: #606266;
}
.setting-hint {
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}
.dialog-wrapper {
  padding: 20px;
}
.image-info {
    position: relative;
    display: inline-block;
    height: 150px;
    border-radius: 10px;
    width: 150px;
  }

.image-info:hover:after {
  content: '+';
  position: absolute;
  text-align: center;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  color: #eee;
  background: rgba(0, 0, 0, 0.4);
  font-size: 24px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: pointer;
  line-height: 150px;
  border-radius: 10px;
}

</style>
